module.exports = __webpack_public_path__ + "assets/img/home_s_i3.bb04aa1d.png";